<script lang="ts">
    import { Button, Icon } from "svelte-materialify/src";
    import { mdiEmail, mdiGithub, mdiLinkedin, mdiOpenInNew } from "@mdi/js";

    export let computerScreen: boolean;
</script>

<div class="contact-container">
    <h6 class="text-h6 primary-text">Contact</h6>
    <div
        class="contact-content d-flex justify-space-around align-center flex-column text-center"
    >
        <a class="primary-text" href="mailto:alexandercarpenter42@gmail.com">
            <Button class="primary-text button-transparent">
                <Icon path={mdiEmail} class="mr-2" />
                {#if computerScreen}
                    alexandercarpenter42@gmail.com
                {:else}
                    Email Me
                {/if}
                <Icon path={mdiOpenInNew} class="ml-2" />
            </Button>
        </a>
        <a
            target="_blank"
            class="primary-text"
            href="https://github.com/Alexander-Carpenter"
        >
            <Button class="primary-text button-transparent">
                <Icon path={mdiGithub} class="mr-2" />
                {#if computerScreen}
                    github.com/Alexander-Carpenter
                {:else}
                    View My GitHub
                {/if}
                <Icon path={mdiOpenInNew} class="ml-2" />
            </Button>
        </a>
        <a
            target="_blank"
            class="primary-text"
            href="https://www.linkedin.com/in/alexander-carpenter-me/"
        >
            <Button class="primary-text button-transparent">
                <Icon path={mdiLinkedin} class="mr-2" />
                {#if computerScreen}
                    linkedin.com/in/alexander-carpenter-me
                {:else}
                    View My LinkedIn
                {/if}
                <Icon path={mdiOpenInNew} class="ml-2" />
            </Button>
        </a>
    </div>
</div>

<style>
    .contact-container {
        height: 100vh !important;
    }

    .contact-content {
        height: calc(100vh - 32px) !important;
    }
</style>
